import { useState } from "react";
import { WhatsAppIcon } from "@/components/site/icons";
import { waLink } from "@/lib/contact";

// Builds a WhatsApp message from the form and opens the chat.
export default function ContactForm({ compliant = false }) {
  const [form, setForm] = useState({ nombre: "", tel: "", msg: "" });

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const send = () => {
    const n = form.nombre.trim();
    const t = form.tel.trim();
    const m = form.msg.trim();
    let txt = "Hola, soy " + (n || "—") + ".";
    if (t) txt += " Mi teléfono: " + t + ".";
    if (m) txt += " " + m;
    else if (compliant)
      txt += " Quiero información sobre acompañamiento en bienestar emocional.";
    window.open(waLink(txt), "_blank", "noopener");
  };

  return (
    <div className="rounded-2xl border border-line bg-warm p-7 shadow-soft md:p-8" data-testid="contact-form">
      <div className="mb-4">
        <label htmlFor="nombre" className="mb-1.5 block text-[0.88rem] font-semibold text-ink">
          Nombre
        </label>
        <input
          id="nombre"
          type="text"
          value={form.nombre}
          onChange={set("nombre")}
          placeholder="Tu nombre"
          className="w-full rounded-xl border-[1.5px] border-line bg-band px-4 py-3 text-[0.98rem] text-ink outline-none transition-colors focus:border-spring focus:bg-white"
          data-testid="input-nombre"
        />
      </div>
      <div className="mb-4">
        <label htmlFor="tel" className="mb-1.5 block text-[0.88rem] font-semibold text-ink">
          Teléfono
        </label>
        <input
          id="tel"
          type="tel"
          value={form.tel}
          onChange={set("tel")}
          placeholder="Para poder contactarte"
          className="w-full rounded-xl border-[1.5px] border-line bg-band px-4 py-3 text-[0.98rem] text-ink outline-none transition-colors focus:border-spring focus:bg-white"
          data-testid="input-tel"
        />
      </div>
      <div className="mb-5">
        <label htmlFor="msg" className="mb-1.5 block text-[0.88rem] font-semibold text-ink">
          ¿En qué podemos ayudarte?
        </label>
        <textarea
          id="msg"
          rows={4}
          value={form.msg}
          onChange={set("msg")}
          placeholder={
            compliant
              ? "Cuéntanos brevemente cómo te sientes"
              : "Cuéntanos brevemente tu situación"
          }
          className="w-full resize-none rounded-xl border-[1.5px] border-line bg-band px-4 py-3 text-[0.98rem] text-ink outline-none transition-colors focus:border-spring focus:bg-white"
          data-testid="input-msg"
        />
      </div>
      <button
        type="button"
        onClick={send}
        className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-marigold px-6 py-3.5 font-semibold text-[#231402] shadow-soft transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#e0994c] hover:shadow-lift"
        data-testid="contact-submit"
      >
        <WhatsAppIcon className="h-[1.15em] w-[1.15em]" />
        Enviar por WhatsApp
      </button>
      <small className="mt-3 block text-center text-[0.8rem] text-soft">
        Al enviar se abrirá WhatsApp con tu mensaje listo. Atención confidencial.
      </small>
    </div>
  );
}
